import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Link } from 'react-router-dom'

const HeroSlider = () => {
  const [activeSlide, setActiveSlide] = useState(0)

  const slides = [
    {
      id: 1,
      title: "Powering Your Success: Staffing & HR Solutions",
      subtitle: "Shrijaa Outsourcing Consultants — connecting organizations with the right workforce efficiently and reliably across India.",
      image: "/hero-home-1.jpg",
      cta: "Get In Touch",
      ctaLink: "/contact"
    },
    {
      id: 2,
      title: "Find Skilled Talent for Your Business",
      subtitle: "Access a pool of qualified, verified professionals ready to drive your business forward.",
      image: "/hero-home-2.jpg",
      cta: "Explore Services",
      ctaLink: "/services"
    },
    {
      id: 3,
      title: "Comprehensive Manpower Solutions",
      subtitle: "From housekeeping to event staffing — one trusted partner for all your workforce needs.",
      image: "/hero-home-3.jpg",
      cta: "Learn More",
      ctaLink: "/about"
    }
  ]

  return (
    <div className="relative h-[500px] md:h-[600px] lg:h-[650px] overflow-hidden">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{
          clickable: true,
          el: '.swiper-pagination',
          bulletClass: 'inline-block w-3 h-3 rounded-full bg-white/40 mx-1.5 cursor-pointer transition-all duration-300',
          bulletActiveClass: '!bg-accent-500 !w-8',
        }}
        speed={600}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
        className="h-full"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="relative h-full">
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover bg-no-repeat"
                style={{ 
                  backgroundImage: `url(${slide.image})`,
                  backgroundPosition: 'center 15%'
                }}
              >
                <div className="absolute inset-0 bg-black/30"></div>
              </div>

              {/* Content */}
              <div className="relative h-full flex items-center">
                <div className="container-max w-full">
                  <div className="max-w-2xl">
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white leading-tight">
                      {slide.title}
                    </h1>
                    <p className="text-base md:text-lg mb-8 text-white/80 leading-relaxed max-w-xl">
                      {slide.subtitle}
                    </p>
                    <Link
                      to={slide.ctaLink}
                      className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-semibold py-3.5 px-8 rounded-md text-base transition-all duration-200 uppercase tracking-wide"
                    >
                      {slide.cta} →
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Pagination */}
      <div className="swiper-pagination absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 flex items-center"></div>
    </div>
  )
}

export default HeroSlider
